import { createFileRoute } from "@tanstack/react-router";

// Inline zod-free validator so the eager stub does NOT pull in zod
// (and the whole form-vendor chunk) on initial load. The lazy route
// component still uses zod for richer logic; the validator only needs
// to coerce `?view=` into a known enum value before the chunk loads.
const ALLOWED_VIEWS = new Set(["kanban", "list"] as const);
type AllowedView = "kanban" | "list";
function validateBoardSearch(search: Record<string, unknown>): { view?: AllowedView } {
  const v = search?.view;
  if (typeof v === "string" && ALLOWED_VIEWS.has(v as AllowedView)) {
    return { view: v as AllowedView };
  }
  return {};
}

export const Route = createFileRoute("/_authenticated/board/\$boardId")({
  validateSearch: validateBoardSearch,
}).lazy(() => import("./\$boardId.lazy").then((d) => d.Route));
